import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifyService } from '../../../core/services';
import { Notifications, ToastTypes, NotificationsHeading } from '../../../configs/app.config';

@Component({
  selector: 'sra-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent {
  @Input() title = 'Popup Title';
  @Input() subTitle?: string;
  @Input() subTitleSuffix?: string;
  @Input() showHeader = true; // Add an input to control the header
  @Input() showFooter = true; // Add an input to control the footer
  @Input() isImagePopup = false;
  @Input() value?: string;
  @Input() showOk?: boolean;
  // new inputs for download support
  @Input() showDownload = false;
  @Input() downloadUrl?: string;
  @Input() downloadFileName?: string;
  @Output() userSelected = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();
  isVisible = false;

  constructor(
    private readonly notifyService: NotifyService,
    private readonly httpClient: HttpClient,
  ) { }

  openPopup(): void {
    this.isVisible = true;
  }

  closePopup(): void {
    this.isVisible = false;
    this.closed.emit();
  }

  emitValue() {
    this.userSelected.emit(this.value);
    this.closePopup()
  }

  /**
   * Clicks Download icon to download the popup image
   * @param event
   * @returns
   */
  onDownloadClick(): void {
    const url = this.downloadUrl;
    if (!url) return;
    const fileName = this.extractFileName(url);
    const ext = this.getFileExtension(fileName);
    const fileType = `image/${ext}`;
    this.downloadFile(url, fileName, fileType);
  }

  /**
   * Downloads the image file
   * @param url
   * @param fileName
   * @param fileType
   */
  downloadFile(url: string, fileName: string, fileType: string): void {
    this.httpClient.get(url, { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        const file = new Blob([blob], { type: fileType });
        const fileURL = window.URL.createObjectURL(file);

        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(fileURL);
        this.notifyService.show(
          ToastTypes.Success,
          NotificationsHeading.SUCCESS,
          Notifications.FILE_DOWNLOADED
        );
      });
  }

  /**
   * Extracts Filename from the url string
   * @param url
   * @returns
   */
  private extractFileName(url: string): string {
    if (!url) return 'download';
    const cleanUrl = url.split('?')[0].split('#')[0]; // Remove query string (&, ?, etc.)
    const decodedUrl = decodeURIComponent(cleanUrl); // Decode URL-encoded characters
    let fileName = decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1); // Extract just the filename
    // Remove GUID pattern: _xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx before file extension
    fileName = fileName.replace(/_[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}(?=\.|$)/i, '');
    return fileName || 'download'; // Fallback if nothing found
  }

  /**
   * Extracts file extension
   * @param filename
   * @returns
   */
  getFileExtension(filename: string): string {
    if (!filename) return '';
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
  }
}
